/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenInvoiceOverview } from './OpenInvoiceOverview';
import {
    OpenInvoiceOverviewFromJSON,
    OpenInvoiceOverviewFromJSONTyped,
    OpenInvoiceOverviewToJSON,
    OpenInvoiceOverviewToJSONTyped,
} from './OpenInvoiceOverview';

/**
 * 
 * @export
 * @interface OpenInvoiceSummary
 */
export interface OpenInvoiceSummary {
    /**
     * 
     * @type {number}
     * @memberof OpenInvoiceSummary
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OpenInvoiceSummary
     */
    total: number;
    /**
     * 
     * @type {Array<OpenInvoiceOverview>}
     * @memberof OpenInvoiceSummary
     */
    openInvoices: Array<OpenInvoiceOverview>;
}

/**
 * Check if a given object implements the OpenInvoiceSummary interface.
 */
export function instanceOfOpenInvoiceSummary(value: object): value is OpenInvoiceSummary {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('openInvoices' in value) || value['openInvoices'] === undefined) return false;
    return true;
}

export function OpenInvoiceSummaryFromJSON(json: any): OpenInvoiceSummary {
    return OpenInvoiceSummaryFromJSONTyped(json, false);
}

export function OpenInvoiceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenInvoiceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'total': json['total'],
        'openInvoices': ((json['openInvoices'] as Array<any>).map(OpenInvoiceOverviewFromJSON)),
    };
}

export function OpenInvoiceSummaryToJSON(json: any): OpenInvoiceSummary {
    return OpenInvoiceSummaryToJSONTyped(json, false);
}

export function OpenInvoiceSummaryToJSONTyped(value?: OpenInvoiceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'total': value['total'],
        'openInvoices': ((value['openInvoices'] as Array<any>).map(OpenInvoiceOverviewToJSON)),
    };
}

